export default __webpack_public_path__ + "static/media/labor_927_2.db2a3bc0.jpg";